<template>
  <div class="container">
    <section v-if="error" class="section section-shaped pt-lg-md pb-5 mp-5">
      <div class="shape">
        <span></span>
        <h4 class="mb-0 font-weight-light">We're sorry, we're not able to retrieve this information at the moment, please try back later</h4>
      </div>
    </section>
    <section class="section" v-else>
      <b-container class="bv-example-row">
        <b-row align-h="between">
          <b-col cols="12" sm="8"><h4>WhatsApp and Telegram Stickers Directory</h4></b-col>
          <b-col cols="12"  sm="2" >
            <div>
              <b-form-select  v-model="selected" :options="options" v-on:input="orderMethod($event)"></b-form-select>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="text-center section section-shaped pt-lg-md pb-5 mp-5" v-if="loading"><h4>Loading...</h4></div>
      <b-container class="bv-example-row" v-else>
        <b-row class="d-flex justify-content-center" v-for="chunk in postChunks" :key="chunk.id">
          <b-col cols="6" md="3" class="ml-auto p-3" no-gutters v-for="post in chunk" :key="post.id">
            <router-link  :to="{ name: 'stickers', params: { id: post.link } }" class="nav-link nav-link-icon" role="button">
              <b-card  :header="`${post.name}`" header-class="text-truncate text-center">
                <b-img-lazy v-bind="mainProps" :alt="`${post.name}`" :src="`${baseURL}/v2/uploads/${post.id}/thumb128.webp`"></b-img-lazy>
              </b-card>
            </router-link>
          </b-col>
        </b-row>
      </b-container>
      <base-pagination class="mt-5" v-model="page" :page-count="totalPages" v-on:input="pageMethod($event)" align="center">
      </base-pagination>
      <br>
      <br>
    </section>
  </div>
</template>
<script>
import { HTTP } from './http-common'
import chunk from 'lodash/chunk'

export default {
  data () {
    return {
      status: 'not_accepted',
      aviso: false,
      avisoError: false,
      link: null,
      loading: false,
      bottom: true,
      post: [],
      error: false,
      baseURL: process.env.VUE_APP_ROOT_API,
      page: 1,
      totalPages: 0,
      mainProps: {
        center: true,
        fluid: true,
        blank: true,
        blankColor: '#ffffff',
        width: 96,
        height: 96,
        class: 'mx-1'
      },
      selected: null,
      options: [
        { value: null, text: 'Order by', disabled: true },
        { value: 'createAt', text: 'Recent' },
        { value: 'installs', text: 'Downloads' }
      ]
    }
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  computed: {
    postChunks () {
      return chunk(Object.values(this.post), 4)
    }
  },
  methods: {
    fetchData () {
      this.selected = this.$route.query.orderBy || 'createAt'
      this.page = parseInt(this.$route.query.page) || 1
      this.error = false
      this.loading = true
      // replace `getPost` with your data fetching util / API wrapper
      HTTP.get(`/v3/setSticker?page=${this.page - 1}&orderBy=${this.selected}`)
        .then(response => {
          this.post = response.data.content
          this.totalPages = response.data.totalPages
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    pageMethod: function (msg) {
      this.$router.push({ path: 'stickers', query: { page: msg } })
    },
    orderMethod: function (msg) {
      this.$router.push({ path: 'stickers', query: { orderBy: msg } })
    },
    pageSticker: function (link) {
      this.$router.push({ name: 'stickers', params: { id: link } })
    },
    enviarLink: function (event) {
      if (this.status === 'not_accepted') {
        alert('I accept the terms and use')
        return
      }
      if (this.link != null && this.link.includes('addstickers')) {
        this.aviso = true
        this.avisoError = false
      } else {
        this.aviso = false
        this.avisoError = true
      }
    }
  }
}
</script>
